var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExport = function SvgExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51817 17L9.62241 15.8958L6.49948 12.7708H14.4641V11.2045H6.49948L9.62241 8.10424L8.51817 7L3.50002 11.9876L8.51817 17Z",
    fill: "#499CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19L3.5 5L19.5 5L19.5 19L3.5 19ZM5.5 21L19.5 21C20.6 21 21.5 20.1 21.5 19L21.5 5C21.5 3.9 20.6 3 19.5 3L5.5 3C4.4 3 3.5 3.9 3.5 5L3.5 19C3.5 20.1 4.4 21 5.5 21Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export { ForwardRef as ReactComponent };